import { render, staticRenderFns } from "./taskDeliverAdd.vue?vue&type=template&id=2283347b&scoped=true"
import script from "./taskDeliverAdd.vue?vue&type=script&lang=js"
export * from "./taskDeliverAdd.vue?vue&type=script&lang=js"
import style0 from "./taskDeliverAdd.vue?vue&type=style&index=0&id=2283347b&prod&lang=css"
import style1 from "./taskDeliverAdd.vue?vue&type=style&index=1&id=2283347b&prod&lang=css"
import style2 from "./taskDeliverAdd.vue?vue&type=style&index=2&id=2283347b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2283347b",
  null
  
)

export default component.exports